import React from "react";
import Clock from "./components/Clock";
import "./App.css";

function App() {
  return (
    <div id="App">
      <Clock />
    </div>
  );
}

export default App;
